module.exports = __webpack_public_path__ + "static/sc2.844bdd20.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/sc2.png
// module id = 484
// module chunks = 114276838955818